import React from 'react';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';

import { LABEL_COLORS_AVAILABLE, POSITIONS, SIZES } from './StastsItem.constants';
import { useStyles } from './styles';

/**
 * @typedef {Object} StatsItemProps
 * @property {boolean} [loading]
 * @property {Function} [onClick]
 * @property {'large' | 'medium' | 'small'} [size]
 * @property {string} [subtitle]
 * @property {string} [title]
 * @property {string | number} value
 * @property {'black' | 'green' | 'yellow' | 'red' | 'blue' | 'purple'} [valueColor]
 * @property {'top' | 'bottom'} [valuePosition]
 */

/**
 * @param {StatsItemProps} props
 */
export const StatsItem = ({
  loading,
  onClick,
  size = SIZES.large,
  subtitle,
  title,
  value,
  valueColor = LABEL_COLORS_AVAILABLE.black,
  valuePosition = POSITIONS.bottom
}) => {
  const classes = useStyles({
    size,
    valueColor,
    valuePosition,
    isClickEnabled: !!onClick && value !== 0
  });

  const valueLabel = (
    <div className="valueLabel">
      <Typography
        className={classes.valueLabel}
        component="span"
        onClick={onClick && value !== 0 && onClick}
      >
        {value}
      </Typography>
    </div>
  );

  return loading ? (
    <Skeleton animation="wave" variant="text" height={50} />
  ) : (
    <div>
      {valuePosition === POSITIONS.top && !!title && valueLabel}
      <Typography className={classes.titleLabel}>{title}</Typography>
      {valuePosition === POSITIONS.bottom && !!title && valueLabel}
      {subtitle && <Typography className={classes.subtitleLabel}>{subtitle}</Typography>}
    </div>
  );
};
